import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { Card, CardContent } from "@profitlens/ui/card";
import { cn } from "@profitlens/ui/cn";

/** 与用户端同款的 KPI 卡片：标签 + 大数字 + 提示/涨跌。 */
export function KpiCard({
  label,
  value,
  hint,
  tone = "default",
  icon: Icon,
  delta,
}: {
  label: string;
  value: string;
  hint?: string;
  tone?: "default" | "positive" | "negative";
  icon?: LucideIcon;
  /** 较上期的变化文案；正数绿、负数红、0 灰。 */
  delta?: { value: number; text: string };
}) {
  return (
    <Card className="transition-shadow hover:shadow-pop">
      <CardContent className="p-4">
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs font-medium text-muted">{label}</p>
          {Icon ? (
            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-brand-soft text-brand">
              <Icon className="h-3.5 w-3.5" />
            </span>
          ) : null}
        </div>
        <p
          className={cn(
            "mt-1 text-xl font-semibold tabular-nums",
            tone === "positive" && "text-success",
            tone === "negative" && "text-danger",
          )}
        >
          {value}
        </p>
        {delta ? (
          <p
            className={cn(
              "mt-1 inline-flex items-center gap-0.5 text-xs font-medium",
              delta.value > 0 && "text-success",
              delta.value < 0 && "text-danger",
              delta.value === 0 && "text-muted",
            )}
          >
            {delta.value > 0 ? (
              <ArrowUpRight className="h-3 w-3" />
            ) : delta.value < 0 ? (
              <ArrowDownRight className="h-3 w-3" />
            ) : null}
            {delta.text}
          </p>
        ) : hint ? (
          <p className="mt-1 text-xs text-muted">{hint}</p>
        ) : null}
      </CardContent>
    </Card>
  );
}
